import { Button, HorizontalSpacer, Label, Layout, Panel, Step, Stepper, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutArchiveVoidedPayables extends Layout {
    buttonArchive: Button;
    horizontalspacer1: HorizontalSpacer;
    labelArchiveTitle: Label;
    panelView: Panel;
    stepArchive: Step;
    stepEditList: Step;
    stepParameters: Step;
    stepperArchiveVoidedPayables: Stepper;
    textboxCutoffDate: Textbox;
    textboxGLDistributionDate: Textbox;
    textboxPayee: Textbox;
}
